/**
 * Agent-Chat Application Entry Point
 */

// Mock API must be imported first to intercept fetch before any API calls
// F15 (chat-ui catch-up): the home-grown dev mock layer was deleted.
// Local dev runs against the dev API directly (or MSW handlers in tests).

import React from 'react'
import { createRoot } from 'react-dom/client'

// Import i18n configuration BEFORE App (order matters!)
import './app/i18n'
import { i18nReady } from './app/i18n-init'

import App from './App'

// Environment variable validation
// Check both runtime config (production) and import.meta.env (dev)
// VITE_WS_URL removed in F4 — VITE_STREAMING_WS_URL is the streaming endpoint.
const requiredEnvVars = ['VITE_API_URL', 'VITE_STREAMING_WS_URL', 'VITE_ADMIN_URL'] as const;
requiredEnvVars.forEach(varName => {
  const runtimeValue = window.__RUNTIME_CONFIG__?.[varName];
  const envValue = import.meta.env[varName];
  if (!runtimeValue && !envValue) {
    console.error(`Missing required environment variable: ${varName}`);
  }
});

const container = document.getElementById('root')
if (!container) {
  throw new Error('Root container element not found')
}

const root = createRoot(container)

// Wait for i18n to initialize before rendering
i18nReady.then(() => {
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  )
})